import { StyleSheet, Platform } from 'react-native';
import theme from '@qnpm/q-theme';
const isAndriod = Platform.OS === 'android';
const { font, responsive: { scale } } = theme;
class TipsStyle {
    constructor(isScale) {
        this.setIsScale = (isScale) => {
            if (typeof isScale === 'boolean' && isScale !== this.isScale) {
                this.isScale = isScale;
            }
        };
        this.TipScale = (size) => {
            return scale(size, this.isScale);
        };
        this.getStyle = () => {
            let TipScale = this.TipScale;
            const tipsContainer = {
                flexDirection: 'row',
                alignItems: 'center',
                paddingVertical: TipScale(5)
            };
            const tipItem = {
                paddingVertical: TipScale(2.2)
            };
            const tip = {
                paddingVertical: TipScale(8),
                overflow: 'hidden',
                flexDirection: 'row',
                alignItems: 'center'
            };
            const container = {
                flex: 1,
                marginRight: TipScale(10),
                overflow: 'hidden'
                // width: 0 // ios bug: width size is wrong (usecase: with react-navigation).
            };
            const content = {
                fontSize: TipScale(12)
            };
            const left0 = {
                marginLeft: 0
            };
            const left2 = {
                marginLeft: TipScale(2)
            };
            const left4 = {
                marginLeft: TipScale(4)
            };
            const left12 = {
                marginLeft: TipScale(12)
            };
            const actionWrap = {
                marginRight: TipScale(12),
                flexDirection: 'row'
            };
            const text = {
                lineHeight: TipScale(18),
                fontSize: TipScale(12)
            };
            const iconTitle = {
                height: TipScale(17),
                paddingHorizontal: TipScale(4),
                marginRight: TipScale(4),
                borderRadius: 2
            };
            const iconTitleText = {
                fontSize: TipScale(11),
                color: '#FFFFFF',
                lineHeight: TipScale(17),
                fontWeight: 'bold'
            };
            const leftIcon = {
                marginRight: TipScale(4),
                marginTop: TipScale(isAndriod ? 0 : -2)
            };
            const cardLeftIcon = {
                marginBottom: TipScale(4),
                flexDirection: 'row',
                alignItems: 'center'
            };
            const cardLeftIconText = {
                fontSize: TipScale(13),
                fontWeight: 'bold'
            };
            const cardLeftIconStyle = {
                marginRight: TipScale(4)
            };
            const ButtonContainer = Object.assign({ borderRadius: TipScale(11), borderWidth: StyleSheet.hairlineWidth, paddingHorizontal: TipScale(10) }, (isAndriod ? { height: TipScale(20) } : {}));
            const ButtonText = {
                fontSize: TipScale(12),
                lineHeight: TipScale(18)
            };
            const moreOperationAreaButton = Object.assign({ borderRadius: TipScale(11), borderWidth: StyleSheet.hairlineWidth, paddingHorizontal: TipScale(10), marginRight: TipScale(8) }, (isAndriod ? { height: TipScale(20) } : {}));
            const rightTextStyle = {
                lineHeight: TipScale(18)
            };
            const rightTextIcon = {
                marginTop: TipScale(1)
            };
            return {
                tipsContainer,
                tipItem,
                tip,
                container,
                content,
                left0,
                left2,
                left4,
                left12,
                actionWrap,
                text,
                iconTitle,
                iconTitleText,
                leftIcon,
                cardLeftIcon,
                cardLeftIconText,
                cardLeftIconStyle,
                ButtonContainer,
                ButtonText,
                moreOperationAreaButton,
                rightTextStyle,
                rightTextIcon
            };
        };
        this.isScale = !!isScale;
        this.fontSize = isScale ? font.size.scaled : font.size.unscaled;
    }
}
export default TipsStyle;
